(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.priceEl = this.querySelector('[data-product-price]');
      this.comparePriceEl = this.querySelector('[data-compare-price]');
      this.imageEl = this.querySelector('.sticky-atc__image-img');
      this.addToCartBtn = this.querySelector('[data-add-to-cart]');
      this.addToCartText = this.querySelector('[data-add-to-cart-text]');

      // theme.js registers theme.Variants/theme.AjaxProduct on the same 'page:loaded'
      // tick this component connects on, so init only once that's actually happened.
      if (window.theme && window.theme.Variants) {
        this.init();
      } else {
        document.addEventListener('page:loaded', () => this.init(), { once: true });
      }
    }

    init() {
      this.setupVariants();

      if (this.form) {
        new theme.AjaxProduct(this.form);
      }

      this.setupVisibility();
    }

    setupVariants() {
      const variantsJson = this.querySelector('[data-variant-json]');
      if (!variantsJson) return;

      const variants = this.variantsData = JSON.parse(variantsJson.textContent);

      // Capture phase: runs before theme.Variants' own change handler on the select,
      // so it already sees the filtered option list (e.g. a colour of the new series).
      this.addEventListener('change', () => this.filterOptions(), true);

      this.variants = new theme.Variants({
        container: this,
        variants: variants,
        singleOptionSelector: '[data-variant-input]',
        originalSelectorId: '[data-product-select]',
        enableHistoryState: false,
        dynamicVariantsEnabled: false
      });

      this.filterOptions();

      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.addEventListener('variantPriceChange', this.onPriceChange.bind(this));
      this.addEventListener('variantImageChange', this.onImageChange.bind(this));
    }

    // Each select only lists values that combine with the options before it (a colour
    // select shows the chosen series' colours), sold out ones disabled. Options are
    // removed rather than hidden: Safari ignores `hidden`/display:none on <option>.
    filterOptions() {
      const selects = this.getSelects();

      selects.forEach((select, i) => {
        if (!select._allOptions) select._allOptions = Array.from(select.options);

        const preceding = selects.slice(0, i).map((s) => [s.dataset.index, s.value]);
        const matches = this.variantsData.filter((v) => preceding.every(([index, value]) => v[index] === value));
        const index = select.dataset.index;
        const current = select.value;

        const kept = select._allOptions.filter((option) => matches.some((v) => v[index] === option.value));
        kept.forEach((option) => {
          option.disabled = !matches.some((v) => v[index] === option.value && v.available);
        });

        const unchanged = kept.length === select.options.length && kept.every((option, k) => select.options[k] === option);
        if (!unchanged) select.replaceChildren(...kept);

        const keep = kept.find((option) => option.value === current) || kept.find((option) => !option.disabled) || kept[0];
        if (keep) select.value = keep.value;
      });
    }

    getSelects() {
      return Array.from(this.querySelectorAll('select[data-variant-input]'));
    }

    // Mirror a selection made in the main product form, option by option, so each
    // select is filtered for the values before it. [[ 'option1', 'Micarta' ], ...]
    applySelection(selection) {
      const selects = this.getSelects();
      let changed = null;

      selection.forEach(([index, value]) => {
        const select = selects.find((s) => s.dataset.index === index);
        if (!select || select.value === value) return;

        this.filterOptions();
        select.value = value;
        changed = select;
      });

      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onVariantChange(evt) {
      const variant = evt.detail.variant;
      if (!this.addToCartBtn || !this.addToCartText) return;

      if (variant && variant.available) {
        this.addToCartBtn.disabled = false;
        this.addToCartText.textContent = this.addToCartText.dataset.defaultText;
      } else {
        this.addToCartBtn.disabled = true;
        this.addToCartText.textContent = this.dataset.soldOutText;
      }
    }

    onPriceChange(evt) {
      const variant = evt.detail.variant;
      if (!variant || !this.priceEl) return;

      this.priceEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

      if (variant.compare_at_price > variant.price) {
        this.priceEl.classList.add('sale-price');
        if (this.comparePriceEl) {
          this.comparePriceEl.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
          this.comparePriceEl.classList.remove('hide');
        }
      } else {
        this.priceEl.classList.remove('sale-price');
        if (this.comparePriceEl) {
          this.comparePriceEl.innerHTML = '';
          this.comparePriceEl.classList.add('hide');
        }
      }
    }

    onImageChange(evt) {
      const variant = evt.detail.variant;
      const src = variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src;
      if (!src || !this.imageEl) return;

      // Use Shopify CDN's width param instead of theme.Images.getSizedImageUrl: that
      // helper only recognizes a handful of file extensions (not .heic, which several
      // of this product's variant images are uploaded as) and silently returns null.
      const separator = src.includes('?') ? '&' : '?';

      // image-element.liquid renders this <img> with srcset/sizes (for the responsive
      // initial load), and srcset always wins over src once present - so just setting
      // .src here would silently do nothing. Drop srcset so the new src actually renders.
      this.imageEl.removeAttribute('srcset');
      this.imageEl.removeAttribute('sizes');
      this.imageEl.src = `${src}${separator}width=160`;
    }

    setupVisibility() {
      const trigger = document.querySelector('[data-product-blocks] [data-add-to-cart]');
      const footer = document.querySelector('.site-footer');
      if (!trigger) return;

      let pastTrigger = false;
      let footerVisible = false;

      const update = () => {
        this.classList.toggle('sticky-atc--visible', pastTrigger && !footerVisible);
      };

      new IntersectionObserver((entries) => {
        const entry = entries[0];
        pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      }).observe(trigger);

      if (footer) {
        new IntersectionObserver((entries) => {
          footerVisible = entries[0].isIntersecting;
          update();
        }).observe(footer);
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);

  // theme.Variants already dispatches a page-wide 'variant:change' event on every
  // selector change (assets/theme.js), it just had no listener. Use it to keep this
  // bar's own selects and the main product form's selects mirroring each other,
  // regardless of which one the customer actually changed.
  //
  // Mirror the whole resolved variant, not just the changed option: switching the
  // series makes theme.Variants pick a colour of that series too, and the other form
  // has to follow both.
  document.addEventListener('variant:change', (evt) => {
    const { index, value, variant } = evt.detail;
    let selection = null;

    if (variant && variant.options) {
      selection = variant.options.map((optionValue, i) => [`option${i + 1}`, optionValue]);
    } else if (index && typeof value !== 'undefined') {
      selection = [[index, value]];
    }
    if (!selection) return;

    document.querySelectorAll('sticky-add-to-cart').forEach((bar) => {
      if (bar.applySelection) bar.applySelection(selection);
    });

    // Main product form: set every option first, then fire a single change on the last
    // one touched so theme.Variants resolves the full combination in one go.
    let changed = null;
    selection.forEach(([optionIndex, optionValue]) => {
      document.querySelectorAll(`[data-variant-input][data-index="${optionIndex}"]`).forEach((el) => {
        if (el.closest('sticky-add-to-cart')) return;

        // Selects: one element holds every value. Radios: one element per value -
        // only the one matching the new value should end up checked.
        if (el.tagName === 'SELECT') {
          if (el.value === optionValue) return;
          el.value = optionValue;
          changed = el;
        } else if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.value !== optionValue || el.checked) return;
          el.checked = true;
          changed = el;
        }
      });
    });

    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();
})();
